webpackJsonp(["pages.explore.groups"],{

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/app.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_modal_vue__ = __webpack_require__("./vue_shared/components/modal.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_hub__ = __webpack_require__("./groups/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("./groups/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__groups_vue__ = __webpack_require__("./groups/components/groups.vue");

/* global Flash */











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    loadingIcon: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_modal_vue__["a" /* default */],
    groupsComponent: __WEBPACK_IMPORTED_MODULE_7__groups_vue__["a" /* default */]
  },
  props: {
    store: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    },
    hideProjects: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: true,
      isSearchEmpty: false,
      searchEmptyMessage: '',
      showModal: false,
      groupLeaveConfirmationMessage: '',
      targetGroup: null,
      targetParentGroup: null
    };
  },

  computed: {
    groups: function groups() {
      return this.store.getGroups();
    },
    pageInfo: function pageInfo() {
      return this.store.getPaginationInfo();
    }
  },
  created: function created() {
    this.searchEmptyMessage = this.hideProjects ? __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COMMON_STR */].GROUP_SEARCH_EMPTY : __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COMMON_STR */].GROUP_PROJECT_SEARCH_EMPTY;

    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$on('fetchPage', this.fetchPage);
    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$on('toggleChildren', this.toggleChildren);
    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$on('showLeaveGroupModal', this.showLeaveGroupModal);
    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$on('updatePagination', this.updatePagination);
    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$on('updateGroups', this.updateGroups);
  },
  mounted: function mounted() {
    this.fetchAllGroups();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$off('fetchPage', this.fetchPage);
    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$off('toggleChildren', this.toggleChildren);
    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$off('showLeaveGroupModal', this.showLeaveGroupModal);
    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$off('updatePagination', this.updatePagination);
    __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$off('updateGroups', this.updateGroups);
  },

  methods: {
    fetchGroups: function fetchGroups(_ref) {
      var _this = this;

      var parentId = _ref.parentId,
          page = _ref.page,
          filterGroupsBy = _ref.filterGroupsBy,
          sortBy = _ref.sortBy,
          archived = _ref.archived,
          updatePagination = _ref.updatePagination;

      return this.service.getGroups(parentId, page, filterGroupsBy, sortBy, archived).then(function (res) {
        if (updatePagination) {
          _this.updatePagination(res.headers);
        }

        return res;
      }).then(function (res) {
        return res.json();
      }).catch(function () {
        _this.isLoading = false;
        $.scrollTo(0);

        Flash(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COMMON_STR */].FAILURE);
      });
    },
    fetchAllGroups: function fetchAllGroups() {
      var _this2 = this;

      var page = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__["i" /* getParameterByName */])('page') || null;
      var sortBy = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__["i" /* getParameterByName */])('sort') || null;
      var archived = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__["i" /* getParameterByName */])('archived') || null;
      var filterGroupsBy = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__["i" /* getParameterByName */])('filter') || null;

      this.isLoading = true;
      // eslint-disable-next-line promise/catch-or-return
      this.fetchGroups({
        page: page,
        filterGroupsBy: filterGroupsBy,
        sortBy: sortBy,
        archived: archived,
        updatePagination: true
      }).then(function (res) {
        _this2.isLoading = false;
        _this2.updateGroups(res, Boolean(filterGroupsBy));
      });
    },
    fetchPage: function fetchPage(page, filterGroupsBy, sortBy, archived) {
      var _this3 = this;

      this.isLoading = true;

      // eslint-disable-next-line promise/catch-or-return
      this.fetchGroups({
        page: page,
        filterGroupsBy: filterGroupsBy,
        sortBy: sortBy,
        archived: archived,
        updatePagination: true
      }).then(function (res) {
        _this3.isLoading = false;
        $.scrollTo(0);

        var currentPath = Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils_url_utility__["c" /* mergeUrlParams */])({ page: page }, window.location.href);
        window.history.replaceState({
          page: currentPath
        }, document.title, currentPath);

        _this3.updateGroups(res);
      });
    },
    toggleChildren: function toggleChildren(group) {
      var _this4 = this;

      var parentGroup = group;
      if (!parentGroup.isOpen) {
        if (parentGroup.children.length === 0) {
          parentGroup.isChildrenLoading = true;
          // eslint-disable-next-line promise/catch-or-return
          this.fetchGroups({
            parentId: parentGroup.id
          }).then(function (res) {
            _this4.store.setGroupChildren(parentGroup, res);
          }).catch(function () {
            parentGroup.isChildrenLoading = false;
          });
        } else {
          parentGroup.isOpen = true;
        }
      } else {
        parentGroup.isOpen = false;
      }
    },
    showLeaveGroupModal: function showLeaveGroupModal(group, parentGroup) {
      this.targetGroup = group;
      this.targetParentGroup = parentGroup;
      this.showModal = true;
      this.groupLeaveConfirmationMessage = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('GroupsTree|Are you sure you want to leave the "' + group.fullName + '" group?');
    },
    hideLeaveGroupModal: function hideLeaveGroupModal() {
      this.showModal = false;
    },
    leaveGroup: function leaveGroup() {
      var _this5 = this;

      this.showModal = false;
      this.targetGroup.isBeingRemoved = true;
      this.service.leaveGroup(this.targetGroup.leavePath).then(function (res) {
        return res.json();
      }).then(function (res) {
        $.scrollTo(0);
        _this5.store.removeGroup(_this5.targetGroup, _this5.targetParentGroup);
        Flash(res.notice, 'notice');
      }).catch(function (err) {
        var message = __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COMMON_STR */].FAILURE;
        if (err.status === 403) {
          message = __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COMMON_STR */].LEAVE_FORBIDDEN;
        }
        Flash(message);
        _this5.targetGroup.isBeingRemoved = false;
      });
    },
    updatePagination: function updatePagination(headers) {
      this.store.setPaginationInfo(headers);
    },
    updateGroups: function updateGroups(groups, fromSearch) {
      this.isSearchEmpty = groups ? groups.length === 0 : false;
      if (fromSearch) {
        this.store.setSearchedGroups(groups);
      } else {
        this.store.setGroups(groups);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./filterable_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Makes search request for content when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var FilterableList = function () {
  function FilterableList(form, filter, holder) {
    var filterInputField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'filter_groups';

    _classCallCheck(this, FilterableList);

    this.filterForm = form;
    this.listFilterElement = filter;
    this.listHolderElement = holder;
    this.filterInputField = filterInputField;
    this.isBusy = false;
  }

  _createClass(FilterableList, [{
    key: 'getFilterEndpoint',
    value: function getFilterEndpoint() {
      return this.filterForm.getAttribute('action') + '?' + $(this.filterForm).serialize();
    }
  }, {
    key: 'getPagePath',
    value: function getPagePath() {
      return this.getFilterEndpoint();
    }
  }, {
    key: 'initSearch',
    value: function initSearch() {
      // Wrap to prevent passing event arguments to .filterResults;
      this.debounceFilter = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(this.onFilterInput.bind(this), 500);

      this.unbindEvents();
      this.bindEvents();
    }
  }, {
    key: 'onFilterInput',
    value: function onFilterInput() {
      var $form = $(this.filterForm);
      var queryData = {};
      var filterGroupsParam = $form.find('[name="' + this.filterInputField + '"]').val();

      if (filterGroupsParam) {
        queryData[this.filterInputField] = filterGroupsParam;
      }

      this.filterResults(queryData);

      if (this.setDefaultFilterOption) {
        this.setDefaultFilterOption();
      }
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.listFilterElement.addEventListener('input', this.debounceFilter);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.listFilterElement.removeEventListener('input', this.debounceFilter);
    }
  }, {
    key: 'filterResults',
    value: function filterResults(params) {
      var _this = this;

      if (this.isBusy) {
        return false;
      }

      $(this.listHolderElement).fadeTo(250, 0.5);

      this.isBusy = true;

      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(this.getFilterEndpoint(), {
        params: params
      }).then(function (res) {
        _this.onFilterSuccess(res, params);
        _this.onFilterComplete();
      }).catch(function () {
        return _this.onFilterComplete();
      });
    }
  }, {
    key: 'onFilterSuccess',
    value: function onFilterSuccess(response, queryData) {
      if (response.data.html) {
        this.listHolderElement.innerHTML = response.data.html;
      }

      // Change url so if user reload a page - search results are saved
      var currentPath = this.getPagePath(queryData);

      return window.history.replaceState({
        page: currentPath
      }, document.title, currentPath);
    }
  }, {
    key: 'onFilterComplete',
    value: function onFilterComplete() {
      this.isBusy = false;
      $(this.listHolderElement).fadeTo(250, 1);
    }
  }]);

  return FilterableList;
}();

/* harmony default export */ __webpack_exports__["a"] = (FilterableList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./groups/components/groups.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/table_pagination.vue + 2 modules
var table_pagination = __webpack_require__("./vue_shared/components/table_pagination.vue");

// EXTERNAL MODULE: ./groups/event_hub.js
var event_hub = __webpack_require__("./groups/event_hub.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/groups.vue





/* harmony default export */ var groups = ({
  components: {
    tablePagination: table_pagination["a" /* default */]
  },
  props: {
    groups: {
      type: Array,
      required: true
    },
    pageInfo: {
      type: Object,
      required: true
    },
    searchEmpty: {
      type: Boolean,
      required: true
    },
    searchEmptyMessage: {
      type: String,
      required: true
    }
  },
  methods: {
    change: function change(page) {
      var filterGroupsParam = Object(common_utils["i" /* getParameterByName */])('filter_groups');
      var sortParam = Object(common_utils["i" /* getParameterByName */])('sort');
      var archivedParam = Object(common_utils["i" /* getParameterByName */])('archived');
      event_hub["a" /* default */].$emit('fetchPage', page, filterGroupsParam, sortParam, archivedParam);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00b60c28","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/groups.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"groups-list-tree-container"},[(_vm.searchEmpty)?_c('div',{staticClass:"has-no-search-results"},[_vm._v("\n    "+_vm._s(_vm.searchEmptyMessage)+"\n  ")]):_vm._e(),_vm._v(" "),(!_vm.searchEmpty)?_c('group-folder',{attrs:{"groups":_vm.groups}}):_vm._e(),_vm._v(" "),(!_vm.searchEmpty)?_c('table-pagination',{attrs:{"change":_vm.change,"page-info":_vm.pageInfo}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./groups/components/groups.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  groups,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_groups = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./groups/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAX_CHILDREN_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMMON_STR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ITEM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GROUP_VISIBILITY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PROJECT_VISIBILITY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VISIBILITY_TYPE_ICON; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");


var MAX_CHILDREN_COUNT = 20;

var COMMON_STR = {
  FAILURE: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('An error occurred. Please try again.'),
  LEAVE_FORBIDDEN: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('GroupsTree|Failed to leave the group. Please make sure you are not the only owner.'),
  LEAVE_BTN_TITLE: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('GroupsTree|Leave this group'),
  EDIT_BTN_TITLE: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('GroupsTree|Edit group'),
  GROUP_SEARCH_EMPTY: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('GroupsTree|Sorry, no groups matched your search'),
  GROUP_PROJECT_SEARCH_EMPTY: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('GroupsTree|Sorry, no groups or projects matched your search')
};

var ITEM_TYPE = {
  PROJECT: 'project',
  GROUP: 'group'
};

var GROUP_VISIBILITY_TYPE = {
  public: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('Public - The group and any public projects can be viewed without any authentication.'),
  internal: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('Internal - The group and any internal projects can be viewed by any logged in user.'),
  private: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('Private - The group and its projects can only be viewed by members.')
};

var PROJECT_VISIBILITY_TYPE = {
  public: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('Public - The project can be accessed without any authentication.'),
  internal: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('Internal - The project can be accessed by any logged in user.'),
  private: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('Private - Project access must be granted explicitly to each user.')
};

var VISIBILITY_TYPE_ICON = {
  public: 'earth',
  internal: 'shield',
  private: 'lock'
};

/***/ }),

/***/ "./groups/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./groups/groups_filterable_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filterable_list__ = __webpack_require__("./filterable_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_hub__ = __webpack_require__("./groups/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var GroupFilterableList = function (_FilterableList) {
  _inherits(GroupFilterableList, _FilterableList);

  function GroupFilterableList(_ref) {
    var form = _ref.form,
        filter = _ref.filter,
        holder = _ref.holder,
        filterEndpoint = _ref.filterEndpoint,
        pagePath = _ref.pagePath,
        dropdownSel = _ref.dropdownSel,
        filterInputField = _ref.filterInputField;

    _classCallCheck(this, GroupFilterableList);

    var _this = _possibleConstructorReturn(this, (GroupFilterableList.__proto__ || Object.getPrototypeOf(GroupFilterableList)).call(this, form, filter, holder, filterInputField));

    _this.form = form;
    _this.filterEndpoint = filterEndpoint;
    _this.pagePath = pagePath;
    _this.filterInputField = filterInputField;
    _this.$dropdown = $(dropdownSel);
    return _this;
  }

  _createClass(GroupFilterableList, [{
    key: 'getFilterEndpoint',
    value: function getFilterEndpoint() {
      return this.filterEndpoint;
    }
  }, {
    key: 'getPagePath',
    value: function getPagePath(queryData) {
      var params = queryData ? $.param(queryData) : '';
      var queryString = params ? '?' + params : '';
      return '' + this.pagePath + queryString;
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      _get(GroupFilterableList.prototype.__proto__ || Object.getPrototypeOf(GroupFilterableList.prototype), 'bindEvents', this).call(this);

      this.onFilterOptionClikWrapper = this.onOptionClick.bind(this);

      this.$dropdown.on('click', 'a', this.onFilterOptionClikWrapper);
    }
  }, {
    key: 'onFilterInput',
    value: function onFilterInput() {
      var queryData = {};
      var $form = $(this.form);
      var archivedParam = Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["i" /* getParameterByName */])('archived', window.location.href);
      var filterGroupsParam = $form.find('[name="' + this.filterInputField + '"]').val();

      if (filterGroupsParam) {
        queryData[this.filterInputField] = filterGroupsParam;
      }

      if (archivedParam) {
        queryData.archived = archivedParam;
      }

      this.filterResults(queryData);

      if (this.setDefaultFilterOption) {
        this.setDefaultFilterOption();
      }
    }
  }, {
    key: 'setDefaultFilterOption',
    value: function setDefaultFilterOption() {
      var defaultOption = $.trim(this.$dropdown.find('.dropdown-menu li.js-filter-sort-order a').first().text());
      this.$dropdown.find('.dropdown-label').text(defaultOption);
    }
  }, {
    key: 'onOptionClick',
    value: function onOptionClick(e) {
      e.preventDefault();

      var queryData = {};

      // Get type of option selected from dropdown
      var currentTargetClassList = e.currentTarget.parentElement.classList;
      var isOptionFilterBySort = currentTargetClassList.contains('js-filter-sort-order');
      var isOptionFilterByArchivedProjects = currentTargetClassList.contains('js-filter-archived-projects');

      // Get option query param, also preserve currently applied query param
      var sortParam = Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["i" /* getParameterByName */])('sort', isOptionFilterBySort ? e.currentTarget.href : window.location.href);
      var archivedParam = Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["i" /* getParameterByName */])('archived', isOptionFilterByArchivedProjects ? e.currentTarget.href : window.location.href);

      if (sortParam) {
        queryData.sort = sortParam;
      }

      if (archivedParam) {
        queryData.archived = archivedParam;
      }

      this.filterResults(queryData);

      // Active selected option
      if (isOptionFilterBySort) {
        this.$dropdown.find('.dropdown-label').text($.trim(e.currentTarget.text));
        this.$dropdown.find('.dropdown-menu li.js-filter-sort-order a').removeClass('is-active');
      } else if (isOptionFilterByArchivedProjects) {
        this.$dropdown.find('.dropdown-menu li.js-filter-archived-projects a').removeClass('is-active');
      }

      $(e.target).addClass('is-active');

      // Clear current value on search form
      this.form.querySelector('[name="' + this.filterInputField + '"]').value = '';
    }
  }, {
    key: 'onFilterSuccess',
    value: function onFilterSuccess(res, queryData) {
      var currentPath = this.getPagePath(queryData);

      window.history.replaceState({
        page: currentPath
      }, document.title, currentPath);

      __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$emit('updateGroups', res.data, Object.prototype.hasOwnProperty.call(queryData, this.filterInputField));
      __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$emit('updatePagination', Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["x" /* normalizeHeaders */])(res.headers));
    }
  }]);

  return GroupFilterableList;
}(__WEBPACK_IMPORTED_MODULE_0__filterable_list__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GroupFilterableList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./groups/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./vue_shared/translate.js
var translate = __webpack_require__("./vue_shared/translate.js");

// EXTERNAL MODULE: ./groups/groups_filterable_list.js
var groups_filterable_list = __webpack_require__("./groups/groups_filterable_list.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// CONCATENATED MODULE: ./groups/store/groups_store.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var groups_store_GroupsStore = function () {
  function GroupsStore(hideProjects) {
    _classCallCheck(this, GroupsStore);

    this.state = {};
    this.state.groups = [];
    this.state.pageInfo = {};
    this.hideProjects = hideProjects;
  }

  _createClass(GroupsStore, [{
    key: 'setGroups',
    value: function setGroups(rawGroups) {
      var _this = this;

      if (rawGroups && rawGroups.length) {
        this.state.groups = rawGroups.map(function (rawGroup) {
          return _this.formatGroupItem(rawGroup);
        });
      } else {
        this.state.groups = [];
      }
    }
  }, {
    key: 'setSearchedGroups',
    value: function setSearchedGroups(rawGroups) {
      var _this2 = this;

      var formatGroups = function formatGroups(groups) {
        return groups.map(function (group) {
          var formattedGroup = _this2.formatGroupItem(group);
          if (formattedGroup.children && formattedGroup.children.length) {
            formattedGroup.children = formatGroups(formattedGroup.children);
          }
          return formattedGroup;
        });
      };

      if (rawGroups && rawGroups.length) {
        this.state.groups = formatGroups(rawGroups);
      } else {
        this.state.groups = [];
      }
    }
  }, {
    key: 'setGroupChildren',
    value: function setGroupChildren(parentGroup, children) {
      var _this3 = this;

      var updatedParentGroup = parentGroup;
      updatedParentGroup.children = children.map(function (rawChild) {
        return _this3.formatGroupItem(rawChild);
      });
      updatedParentGroup.isOpen = true;
      updatedParentGroup.isChildrenLoading = false;
    }
  }, {
    key: 'getGroups',
    value: function getGroups() {
      return this.state.groups;
    }
  }, {
    key: 'setPaginationInfo',
    value: function setPaginationInfo() {
      var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var paginationInfo = void 0;

      if (Object.keys(pagination).length) {
        var normalizedHeaders = Object(common_utils["x" /* normalizeHeaders */])(pagination);
        paginationInfo = Object(common_utils["z" /* parseIntPagination */])(normalizedHeaders);
      } else {
        paginationInfo = pagination;
      }

      this.state.pageInfo = paginationInfo;
    }
  }, {
    key: 'getPaginationInfo',
    value: function getPaginationInfo() {
      return this.state.pageInfo;
    }
  }, {
    key: 'formatGroupItem',
    value: function formatGroupItem(rawGroupItem) {
      var groupChildren = rawGroupItem.children || [];
      var groupIsOpen = groupChildren.length > 0 || false;
      var childrenCount = this.hideProjects ? rawGroupItem.subgroup_count : rawGroupItem.children_count;

      return {
        id: rawGroupItem.id,
        name: rawGroupItem.name,
        fullName: rawGroupItem.full_name,
        description: rawGroupItem.markdown_description,
        visibility: rawGroupItem.visibility,
        avatarUrl: rawGroupItem.avatar_url,
        relativePath: rawGroupItem.relative_path,
        editPath: rawGroupItem.edit_path,
        leavePath: rawGroupItem.leave_path,
        canEdit: rawGroupItem.can_edit,
        canLeave: rawGroupItem.can_leave,
        type: rawGroupItem.type,
        permission: rawGroupItem.permission,
        children: groupChildren,
        isOpen: groupIsOpen,
        isChildrenLoading: false,
        isBeingRemoved: false,
        parentId: rawGroupItem.parent_id,
        childrenCount: childrenCount,
        projectCount: rawGroupItem.project_count,
        subgroupCount: rawGroupItem.subgroup_count,
        memberCount: rawGroupItem.number_users_with_delimiter,
        starCount: rawGroupItem.star_count,
        updatedAt: rawGroupItem.updated_at
      };
    }
  }, {
    key: 'removeGroup',
    value: function removeGroup(group, parentGroup) {
      var updatedParentGroup = parentGroup;
      if (updatedParentGroup.children && updatedParentGroup.children.length) {
        updatedParentGroup.children = parentGroup.children.filter(function (child) {
          return group.id !== child.id;
        });
      } else {
        this.state.groups = this.state.groups.filter(function (child) {
          return group.id !== child.id;
        });
      }
    }
  }]);

  return GroupsStore;
}();

/* harmony default export */ var groups_store = (groups_store_GroupsStore);
// EXTERNAL MODULE: ./vue_shared/vue_resource_interceptor.js
var vue_resource_interceptor = __webpack_require__("./vue_shared/vue_resource_interceptor.js");

// CONCATENATED MODULE: ./groups/service/groups_service.js
var groups_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function groups_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var groups_service_GroupsService = function () {
  function GroupsService(endpoint) {
    groups_service__classCallCheck(this, GroupsService);

    this.groups = vue_esm["a" /* default */].resource(endpoint);
  }

  groups_service__createClass(GroupsService, [{
    key: 'getGroups',
    value: function getGroups(parentId, page, filterGroups, sort, archived) {
      var data = {};

      if (parentId) {
        data.parent_id = parentId;
      } else {
        // Do not send the following param for sub groups
        if (page) {
          data.page = page;
        }

        if (filterGroups) {
          data.filter = filterGroups;
        }

        if (sort) {
          data.sort = sort;
        }

        if (archived) {
          data.archived = archived;
        }
      }

      return this.groups.get(data);
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'leaveGroup',
    value: function leaveGroup(endpoint) {
      return vue_esm["a" /* default */].http.delete(endpoint);
    }
  }]);

  return GroupsService;
}();

/* harmony default export */ var groups_service = (groups_service_GroupsService);
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/app.vue
var app = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/app.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c569e6","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/app.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('loading-icon',{staticClass:"loading-animation prepend-top-20",attrs:{"size":"2","label":_vm.s__('GroupsTree|Loading groups')}}):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('groups-component',{attrs:{"groups":_vm.groups,"search-empty":_vm.isSearchEmpty,"search-empty-message":_vm.searchEmptyMessage,"page-info":_vm.pageInfo}}):_vm._e(),_vm._v(" "),(_vm.showModal)?_c('modal',{attrs:{"kind":"warning","primary-button-label":_vm.__('Leave'),"title":_vm.__('Are you sure?'),"text":_vm.groupLeaveConfirmationMessage},on:{"cancel":_vm.hideLeaveGroupModal,"submit":_vm.leaveGroup}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./groups/components/app.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  app["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_app = (Component.exports);

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./groups/constants.js
var constants = __webpack_require__("./groups/constants.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/group_folder.vue




/* harmony default export */ var group_folder = ({
  props: {
    parentGroup: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    groups: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    hasMoreChildren: function hasMoreChildren() {
      return this.parentGroup.childrenCount > constants["d" /* MAX_CHILDREN_COUNT */];
    },
    moreChildrenStats: function moreChildrenStats() {
      return Object(locale["d" /* n__ */])('One more item', '%d more items', this.parentGroup.childrenCount - this.parentGroup.children.length);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c373d29","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/group_folder.vue
var group_folder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"content-list group-list-tree"},[_vm._l((_vm.groups),function(group,index){return _c('group-item',{key:index,attrs:{"group":group,"parent-group":_vm.parentGroup}})}),_vm._v(" "),(_vm.hasMoreChildren)?_c('li',{staticClass:"group-row"},[_c('a',{staticClass:"group-row-contents has-more-items",attrs:{"href":_vm.parentGroup.relativePath}},[_c('i',{staticClass:"fa fa-external-link",attrs:{"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.moreChildrenStats)+"\n    ")])]):_vm._e()],2)}
var group_folder_staticRenderFns = []

// CONCATENATED MODULE: ./groups/components/group_folder.vue
/* script */


/* template */

/* template functional */
var group_folder___vue_template_functional__ = false
/* styles */
var group_folder___vue_styles__ = null
/* scopeId */
var group_folder___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group_folder___vue_module_identifier__ = null

var group_folder_Component = Object(component_normalizer["a" /* default */])(
  group_folder,
  group_folder_render,
  group_folder_staticRenderFns,
  group_folder___vue_template_functional__,
  group_folder___vue_styles__,
  group_folder___vue_scopeId__,
  group_folder___vue_module_identifier__
)

/* harmony default export */ var components_group_folder = (group_folder_Component.exports);

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/components/identicon.vue + 2 modules
var identicon = __webpack_require__("./vue_shared/components/identicon.vue");

// EXTERNAL MODULE: ./groups/event_hub.js
var event_hub = __webpack_require__("./groups/event_hub.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/item_caret.vue



/* harmony default export */ var item_caret = ({
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    isGroupOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    iconClass: function iconClass() {
      return this.isGroupOpen ? 'angle-down' : 'angle-right';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a988179","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/item_caret.vue
var item_caret_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"folder-caret"},[_c('icon',{attrs:{"size":12,"name":_vm.iconClass}})],1)}
var item_caret_staticRenderFns = []

// CONCATENATED MODULE: ./groups/components/item_caret.vue
/* script */


/* template */

/* template functional */
var item_caret___vue_template_functional__ = false
/* styles */
var item_caret___vue_styles__ = null
/* scopeId */
var item_caret___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var item_caret___vue_module_identifier__ = null

var item_caret_Component = Object(component_normalizer["a" /* default */])(
  item_caret,
  item_caret_render,
  item_caret_staticRenderFns,
  item_caret___vue_template_functional__,
  item_caret___vue_styles__,
  item_caret___vue_scopeId__,
  item_caret___vue_module_identifier__
)

/* harmony default export */ var components_item_caret = (item_caret_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/item_type_icon.vue




/* harmony default export */ var item_type_icon = ({
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    itemType: {
      type: String,
      required: true
    },
    isGroupOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    iconClass: function iconClass() {
      if (this.itemType === constants["c" /* ITEM_TYPE */].GROUP) {
        return this.isGroupOpen ? 'folder-open' : 'folder';
      }
      return 'bookmark';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f517bb3e","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/item_type_icon.vue
var item_type_icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item-type-icon"},[_c('icon',{attrs:{"name":_vm.iconClass}})],1)}
var item_type_icon_staticRenderFns = []

// CONCATENATED MODULE: ./groups/components/item_type_icon.vue
/* script */


/* template */

/* template functional */
var item_type_icon___vue_template_functional__ = false
/* styles */
var item_type_icon___vue_styles__ = null
/* scopeId */
var item_type_icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var item_type_icon___vue_module_identifier__ = null

var item_type_icon_Component = Object(component_normalizer["a" /* default */])(
  item_type_icon,
  item_type_icon_render,
  item_type_icon_staticRenderFns,
  item_type_icon___vue_template_functional__,
  item_type_icon___vue_styles__,
  item_type_icon___vue_scopeId__,
  item_type_icon___vue_module_identifier__
)

/* harmony default export */ var components_item_type_icon = (item_type_icon_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/time_ago_tooltip.vue + 2 modules
var time_ago_tooltip = __webpack_require__("./vue_shared/components/time_ago_tooltip.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/item_stats_value.vue




/* harmony default export */ var item_stats_value = ({
  components: {
    icon: icon["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    cssClass: {
      type: String,
      required: false,
      default: ''
    },
    iconName: {
      type: String,
      required: true
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'bottom'
    },
    /**
     * value could either be number or string
     * as `memberCount` is always passed as string
     * while `subgroupCount` & `projectCount`
     * are always number
     */
    value: {
      type: [Number, String],
      required: false,
      default: ''
    }
  },
  computed: {
    isValuePresent: function isValuePresent() {
      return this.value !== '';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f8081d","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/item_stats_value.vue
var item_stats_value_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"data-container":"body","data-placement":_vm.tooltipPlacement,"title":_vm.title}},[_c('icon',{attrs:{"name":_vm.iconName}}),_vm._v(" "),(_vm.isValuePresent)?_c('span',{staticClass:"stat-value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_vm._e()],1)}
var item_stats_value_staticRenderFns = []

// CONCATENATED MODULE: ./groups/components/item_stats_value.vue
/* script */


/* template */

/* template functional */
var item_stats_value___vue_template_functional__ = false
/* styles */
var item_stats_value___vue_styles__ = null
/* scopeId */
var item_stats_value___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var item_stats_value___vue_module_identifier__ = null

var item_stats_value_Component = Object(component_normalizer["a" /* default */])(
  item_stats_value,
  item_stats_value_render,
  item_stats_value_staticRenderFns,
  item_stats_value___vue_template_functional__,
  item_stats_value___vue_styles__,
  item_stats_value___vue_scopeId__,
  item_stats_value___vue_module_identifier__
)

/* harmony default export */ var components_item_stats_value = (item_stats_value_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/item_stats.vue






/* harmony default export */ var item_stats = ({
  components: {
    icon: icon["a" /* default */],
    timeAgoTooltip: time_ago_tooltip["a" /* default */],
    itemStatsValue: components_item_stats_value
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    visibilityIcon: function visibilityIcon() {
      return constants["f" /* VISIBILITY_TYPE_ICON */][this.item.visibility];
    },
    visibilityTooltip: function visibilityTooltip() {
      if (this.item.type === constants["c" /* ITEM_TYPE */].GROUP) {
        return constants["b" /* GROUP_VISIBILITY_TYPE */][this.item.visibility];
      }
      return constants["e" /* PROJECT_VISIBILITY_TYPE */][this.item.visibility];
    },
    isProject: function isProject() {
      return this.item.type === constants["c" /* ITEM_TYPE */].PROJECT;
    },
    isGroup: function isGroup() {
      return this.item.type === constants["c" /* ITEM_TYPE */].GROUP;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-414ecde0","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/item_stats.vue
var item_stats_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats"},[(_vm.isGroup)?_c('item-stats-value',{attrs:{"css-class":"number-subgroups","icon-name":"folder","title":_vm.__('Subgroups'),"value":_vm.item.subgroupCount}}):_vm._e(),_vm._v(" "),(_vm.isGroup)?_c('item-stats-value',{attrs:{"css-class":"number-projects","icon-name":"bookmark","title":_vm.__('Projects'),"value":_vm.item.projectCount}}):_vm._e(),_vm._v(" "),(_vm.isGroup)?_c('item-stats-value',{attrs:{"css-class":"number-users","icon-name":"users","title":_vm.__('Members'),"value":_vm.item.memberCount}}):_vm._e(),_vm._v(" "),(_vm.isProject)?_c('item-stats-value',{attrs:{"css-class":"project-stars","icon-name":"star","value":_vm.item.starCount}}):_vm._e(),_vm._v(" "),_c('item-stats-value',{attrs:{"css-class":"item-visibility","tooltip-placement":"left","icon-name":_vm.visibilityIcon,"title":_vm.visibilityTooltip}}),_vm._v(" "),(_vm.isProject)?_c('div',{staticClass:"last-updated"},[_c('time-ago-tooltip',{attrs:{"tooltip-placement":"bottom","time":_vm.item.updatedAt}})],1):_vm._e()],1)}
var item_stats_staticRenderFns = []

// CONCATENATED MODULE: ./groups/components/item_stats.vue
/* script */


/* template */

/* template functional */
var item_stats___vue_template_functional__ = false
/* styles */
var item_stats___vue_styles__ = null
/* scopeId */
var item_stats___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var item_stats___vue_module_identifier__ = null

var item_stats_Component = Object(component_normalizer["a" /* default */])(
  item_stats,
  item_stats_render,
  item_stats_staticRenderFns,
  item_stats___vue_template_functional__,
  item_stats___vue_styles__,
  item_stats___vue_scopeId__,
  item_stats___vue_module_identifier__
)

/* harmony default export */ var components_item_stats = (item_stats_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/item_actions.vue






/* harmony default export */ var item_actions = ({
  components: {
    icon: icon["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    parentGroup: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    group: {
      type: Object,
      required: true
    }
  },
  computed: {
    leaveBtnTitle: function leaveBtnTitle() {
      return constants["a" /* COMMON_STR */].LEAVE_BTN_TITLE;
    },
    editBtnTitle: function editBtnTitle() {
      return constants["a" /* COMMON_STR */].EDIT_BTN_TITLE;
    }
  },
  methods: {
    onLeaveGroup: function onLeaveGroup() {
      event_hub["a" /* default */].$emit('showLeaveGroupModal', this.group, this.parentGroup);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a9b1003","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/item_actions.vue
var item_actions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"controls"},[(_vm.group.canEdit)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"edit-group btn no-expand",attrs:{"href":_vm.group.editPath,"title":_vm.editBtnTitle,"aria-label":_vm.editBtnTitle,"data-container":"body","data-placement":"bottom"}},[_c('icon',{attrs:{"name":"settings"}})],1):_vm._e(),_vm._v(" "),(_vm.group.canLeave)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"leave-group btn no-expand",attrs:{"href":_vm.group.leavePath,"title":_vm.leaveBtnTitle,"aria-label":_vm.leaveBtnTitle,"data-container":"body","data-placement":"bottom"},on:{"click":function($event){$event.preventDefault();_vm.onLeaveGroup($event)}}},[_c('icon',{attrs:{"name":"leave"}})],1):_vm._e()])}
var item_actions_staticRenderFns = []

// CONCATENATED MODULE: ./groups/components/item_actions.vue
/* script */


/* template */

/* template functional */
var item_actions___vue_template_functional__ = false
/* styles */
var item_actions___vue_styles__ = null
/* scopeId */
var item_actions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var item_actions___vue_module_identifier__ = null

var item_actions_Component = Object(component_normalizer["a" /* default */])(
  item_actions,
  item_actions_render,
  item_actions_staticRenderFns,
  item_actions___vue_template_functional__,
  item_actions___vue_styles__,
  item_actions___vue_scopeId__,
  item_actions___vue_module_identifier__
)

/* harmony default export */ var components_item_actions = (item_actions_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./groups/components/group_item.vue











/* harmony default export */ var group_item = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    identicon: identicon["a" /* default */],
    itemCaret: components_item_caret,
    itemTypeIcon: components_item_type_icon,
    itemStats: components_item_stats,
    itemActions: components_item_actions
  },
  props: {
    parentGroup: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    group: {
      type: Object,
      required: true
    }
  },
  computed: {
    groupDomId: function groupDomId() {
      return 'group-' + this.group.id;
    },
    rowClass: function rowClass() {
      return {
        'is-open': this.group.isOpen,
        'has-children': this.hasChildren,
        'has-description': this.group.description,
        'being-removed': this.group.isBeingRemoved
      };
    },
    hasChildren: function hasChildren() {
      return this.group.childrenCount > 0;
    },
    hasAvatar: function hasAvatar() {
      return this.group.avatarUrl !== null;
    },
    isGroup: function isGroup() {
      return this.group.type === 'group';
    }
  },
  methods: {
    onClickRowGroup: function onClickRowGroup(e) {
      var NO_EXPAND_CLS = 'no-expand';
      if (!(e.target.classList.contains(NO_EXPAND_CLS) || e.target.parentElement.classList.contains(NO_EXPAND_CLS))) {
        if (this.hasChildren) {
          event_hub["a" /* default */].$emit('toggleChildren', this.group);
        } else {
          Object(url_utility["g" /* visitUrl */])(this.group.relativePath);
        }
      }
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e680b05","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/group_item.vue
var group_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"group-row",class:_vm.rowClass,attrs:{"id":_vm.groupDomId},on:{"click":function($event){$event.stopPropagation();_vm.onClickRowGroup($event)}}},[_c('div',{staticClass:"group-row-contents",class:{ 'project-row-contents': !_vm.isGroup }},[(_vm.isGroup)?_c('item-actions',{attrs:{"group":_vm.group,"parent-group":_vm.parentGroup}}):_vm._e(),_vm._v(" "),_c('item-stats',{attrs:{"item":_vm.group}}),_vm._v(" "),_c('div',{staticClass:"folder-toggle-wrap"},[_c('item-caret',{attrs:{"is-group-open":_vm.group.isOpen}}),_vm._v(" "),_c('item-type-icon',{attrs:{"item-type":_vm.group.type,"is-group-open":_vm.group.isOpen}})],1),_vm._v(" "),_c('div',{staticClass:"avatar-container prepend-top-8 prepend-left-5 s24 hidden-xs",class:{ 'content-loading': _vm.group.isChildrenLoading }},[_c('a',{staticClass:"no-expand",attrs:{"href":_vm.group.relativePath}},[(_vm.hasAvatar)?_c('img',{staticClass:"avatar s24",attrs:{"src":_vm.group.avatarUrl}}):_c('identicon',{attrs:{"size-class":"s24","entity-id":_vm.group.id,"entity-name":_vm.group.name}})],1)]),_vm._v(" "),_c('div',{staticClass:"title namespace-title"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"no-expand",attrs:{"href":_vm.group.relativePath,"title":_vm.group.fullName,"data-placement":"bottom"}},[_vm._v(_vm._s(// ending bracket must be by closing tag to prevent
        // link hover text-decoration from over-extending
        _vm.group.name))]),_vm._v(" "),(_vm.group.permission)?_c('span',{staticClass:"user-access-role"},[_vm._v("\n        "+_vm._s(_vm.group.permission)+"\n      ")]):_vm._e()]),_vm._v(" "),(_vm.group.description)?_c('div',{staticClass:"description"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.group.description)}})]):_vm._e()],1),_vm._v(" "),(_vm.group.isOpen && _vm.hasChildren)?_c('group-folder',{attrs:{"parent-group":_vm.group,"groups":_vm.group.children}}):_vm._e()],1)}
var group_item_staticRenderFns = []

// CONCATENATED MODULE: ./groups/components/group_item.vue
/* script */


/* template */

/* template functional */
var group_item___vue_template_functional__ = false
/* styles */
var group_item___vue_styles__ = null
/* scopeId */
var group_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group_item___vue_module_identifier__ = null

var group_item_Component = Object(component_normalizer["a" /* default */])(
  group_item,
  group_item_render,
  group_item_staticRenderFns,
  group_item___vue_template_functional__,
  group_item___vue_styles__,
  group_item___vue_scopeId__,
  group_item___vue_module_identifier__
)

/* harmony default export */ var components_group_item = (group_item_Component.exports);

// CONCATENATED MODULE: ./groups/index.js










vue_esm["a" /* default */].use(translate["a" /* default */]);

/* harmony default export */ var groups = __webpack_exports__["a"] = (function () {
  var el = document.getElementById('js-groups-tree');

  // Don't do anything if element doesn't exist (No groups)
  // This is for when the user enters directly to the page via URL
  if (!el) {
    return;
  }

  vue_esm["a" /* default */].component('group-folder', components_group_folder);
  vue_esm["a" /* default */].component('group-item', components_group_item);

  // eslint-disable-next-line no-new
  new vue_esm["a" /* default */]({
    el: el,
    components: {
      groupsApp: components_app
    },
    data: function data() {
      var dataset = this.$options.el.dataset;
      var hideProjects = dataset.hideProjects === 'true';
      var store = new groups_store(hideProjects);
      var service = new groups_service(dataset.endpoint);

      return {
        store: store,
        service: service,
        hideProjects: hideProjects,
        loading: true
      };
    },
    beforeMount: function beforeMount() {
      var dataset = this.$options.el.dataset;
      var groupFilterList = null;
      var form = document.querySelector(dataset.formSel);
      var filter = document.querySelector(dataset.filterSel);
      var holder = document.querySelector(dataset.holderSel);

      var opts = {
        form: form,
        filter: filter,
        holder: holder,
        filterEndpoint: dataset.endpoint,
        pagePath: dataset.path,
        dropdownSel: dataset.dropdownSel,
        filterInputField: 'filter'
      };

      groupFilterList = new groups_filterable_list["a" /* default */](opts);
      groupFilterList.initSearch();
    },
    render: function render(createElement) {
      return createElement('groups-app', {
        props: {
          store: this.store,
          service: this.service,
          hideProjects: this.hideProjects
        }
      });
    }
  });
});

/***/ }),

/***/ "./pages/explore/groups/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./filterable_list.js
var filterable_list = __webpack_require__("./filterable_list.js");

// CONCATENATED MODULE: ./groups_list.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Makes search request for groups when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var groups_list_GroupsList = function GroupsList() {
  _classCallCheck(this, GroupsList);

  var form = document.querySelector('form#group-filter-form');
  var filter = document.querySelector('.js-groups-list-filter');
  var holder = document.querySelector('.js-groups-list-holder');

  if (form && filter && holder) {
    var list = new filterable_list["a" /* default */](form, filter, holder);
    list.initSearch();
  }
};

/* harmony default export */ var groups_list = (groups_list_GroupsList);
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./landing.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function landing__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var landing_Landing = function () {
  function Landing(landingElement, dismissButton, cookieName) {
    landing__classCallCheck(this, Landing);

    this.landingElement = landingElement;
    this.cookieName = cookieName;
    this.dismissButton = dismissButton;
    this.eventWrapper = {};
  }

  _createClass(Landing, [{
    key: 'toggle',
    value: function toggle() {
      var isDismissed = this.isDismissed();

      this.landingElement.classList.toggle('hidden', isDismissed);
      if (!isDismissed) this.addEvents();
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.dismissLanding = this.dismissLanding.bind(this);
      this.dismissButton.addEventListener('click', this.eventWrapper.dismissLanding);
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      this.dismissButton.removeEventListener('click', this.eventWrapper.dismissLanding);
    }
  }, {
    key: 'dismissLanding',
    value: function dismissLanding() {
      this.landingElement.classList.add('hidden');
      js_cookie_default.a.set(this.cookieName, 'true', { expires: 365 });
    }
  }, {
    key: 'isDismissed',
    value: function isDismissed() {
      return js_cookie_default.a.get(this.cookieName) === 'true';
    }
  }]);

  return Landing;
}();

/* harmony default export */ var landing = (landing_Landing);
// EXTERNAL MODULE: ./groups/index.js + 25 modules
var groups = __webpack_require__("./groups/index.js");

// CONCATENATED MODULE: ./pages/explore/groups/index.js




document.addEventListener('DOMContentLoaded', function () {
  new groups_list(); // eslint-disable-line no-new
  Object(groups["a" /* default */])();
  var landingElement = document.querySelector('.js-explore-groups-landing');
  if (!landingElement) return;
  var exploreGroupsLanding = new landing(landingElement, landingElement.querySelector('.dismiss-button'), 'explore_groups_landing_dismissed');
  exploreGroupsLanding.toggle();
});

/***/ }),

/***/ "./vue_shared/components/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/icon.vue


/* This is a re-usable vue component for rendering a svg sprite
  icon

  Sample configuration:

  <icon
    name="retry"
    :size="32"
    css-classes="top"
  />

*/
// only allow classes in images.scss e.g. s12
var validSizes = [8, 12, 16, 18, 24, 32, 48, 72];

/* harmony default export */ var icon = ({
  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      required: false,
      default: 16,
      validator: function validator(value) {
        return validSizes.includes(value);
      }
    },

    cssClasses: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: Number,
      required: false,
      default: null
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    y: {
      type: Number,
      required: false,
      default: null
    },

    x: {
      type: Number,
      required: false,
      default: null
    }
  },

  computed: {
    spriteHref: function spriteHref() {
      return gon.sprite_icons + '#' + this.name;
    },
    iconSizeClass: function iconSizeClass() {
      return this.size ? 's' + this.size : '';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43441268","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconSizeClass, _vm.cssClasses],attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y}},[_c('use',_vm._b({},'use',{ 'xlink:href':_vm.spriteHref },false))])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/modal.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/modal.vue
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable vue/require-default-prop */
/* harmony default export */ var modal = ({
  name: 'Modal',

  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    kind: {
      type: String,
      required: false,
      default: 'primary'
    },
    modalDialogClass: {
      type: String,
      required: false,
      default: ''
    },
    closeKind: {
      type: String,
      required: false,
      default: 'default'
    },
    closeButtonLabel: {
      type: String,
      required: false,
      default: 'Cancel'
    },
    primaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    secondaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    submitDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    btnKindClass: function btnKindClass() {
      return _defineProperty({}, 'btn-' + this.kind, true);
    },
    btnCancelKindClass: function btnCancelKindClass() {
      return _defineProperty({}, 'btn-' + this.closeKind, true);
    }
  },

  methods: {
    emitCancel: function emitCancel(event) {
      this.$emit('cancel', event);
    },
    emitSubmit: function emitSubmit(event) {
      this.$emit('submit', event);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e18618c","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal",class:_vm.id ? '' : 'show',attrs:{"id":_vm.id,"role":"dialog","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalDialogClass,attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('h4',{staticClass:"modal-title pull-left"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"close pull-right",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.emitCancel($event)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_c('p',[_vm._v(_vm._s(_vm.text))])],{text:_vm.text})],2),_vm._v(" "),(!_vm.hideFooter)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",class:_vm.btnCancelKindClass,attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.emitCancel($event)}}},[_vm._v("\n            "+_vm._s(_vm.closeButtonLabel)+"\n          ")]),_vm._v(" "),(_vm.secondaryButtonLabel)?_vm._t("secondary-button",[(_vm.secondaryButtonLabel)?_c('button',{staticClass:"btn",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              "+_vm._s(_vm.secondaryButtonLabel)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.primaryButtonLabel)?_c('button',{staticClass:"btn js-primary-button",class:_vm.btnKindClass,attrs:{"type":"button","disabled":_vm.submitDisabled,"data-dismiss":"modal"},on:{"click":function($event){_vm.emitSubmit($event)}}},[_vm._v("\n            "+_vm._s(_vm.primaryButtonLabel)+"\n          ")]):_vm._e()],2):_vm._e()])])]),_vm._v(" "),(!_vm.id)?_c('div',{staticClass:"modal-backdrop fade in"}):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/table_pagination.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/table_pagination.vue



var PAGINATION_UI_BUTTON_LIMIT = 4;
var UI_LIMIT = 6;
var SPREAD = '...';
var PREV = Object(locale["e" /* s__ */])('Pagination|Prev');
var NEXT = Object(locale["e" /* s__ */])('Pagination|Next');
var FIRST = Object(locale["e" /* s__ */])('Pagination|« First');
var LAST = Object(locale["e" /* s__ */])('Pagination|Last »');

/* harmony default export */ var table_pagination = ({
  props: {
    /**
      This function will take the information given by the pagination component
       Here is an example `change` method:
       change(pagenum) {
        gl.utils.visitUrl(`?page=${pagenum}`);
      },
    */
    change: {
      type: Function,
      required: true
    },

    /**
      pageInfo will come from the headers of the API call
      in the `.then` clause of the VueResource API call
      there should be a function that contructs the pageInfo for this component
       This is an example:
       const pageInfo = headers => ({
        perPage: +headers['X-Per-Page'],
        page: +headers['X-Page'],
        total: +headers['X-Total'],
        totalPages: +headers['X-Total-Pages'],
        nextPage: +headers['X-Next-Page'],
        previousPage: +headers['X-Prev-Page'],
      });
    */
    pageInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    prev: function prev() {
      return this.pageInfo.previousPage;
    },
    next: function next() {
      return this.pageInfo.nextPage;
    },
    getItems: function getItems() {
      var total = this.pageInfo.totalPages;
      var page = this.pageInfo.page;
      var items = [];

      if (page > 1) {
        items.push({ title: FIRST, first: true });
      }

      if (page > 1) {
        items.push({ title: PREV, prev: true });
      } else {
        items.push({ title: PREV, disabled: true, prev: true });
      }

      if (page > UI_LIMIT) items.push({ title: SPREAD, separator: true });

      var start = Math.max(page - PAGINATION_UI_BUTTON_LIMIT, 1);
      var end = Math.min(page + PAGINATION_UI_BUTTON_LIMIT, total);

      for (var i = start; i <= end; i += 1) {
        var isActive = i === page;
        items.push({ title: i, active: isActive, page: true });
      }

      if (total - page > PAGINATION_UI_BUTTON_LIMIT) {
        items.push({ title: SPREAD, separator: true, page: true });
      }

      if (page === total) {
        items.push({ title: NEXT, disabled: true, next: true });
      } else if (total - page >= 1) {
        items.push({ title: NEXT, next: true });
      }

      if (total - page >= 1) {
        items.push({ title: LAST, last: true });
      }

      return items;
    },
    showPagination: function showPagination() {
      return this.pageInfo.totalPages > 1;
    }
  },
  methods: {
    changePage: function changePage(text, isDisabled) {
      if (isDisabled) return;

      var _pageInfo = this.pageInfo,
          totalPages = _pageInfo.totalPages,
          nextPage = _pageInfo.nextPage,
          previousPage = _pageInfo.previousPage;


      switch (text) {
        case SPREAD:
          break;
        case LAST:
          this.change(totalPages);
          break;
        case NEXT:
          this.change(nextPage);
          break;
        case PREV:
          this.change(previousPage);
          break;
        case FIRST:
          this.change(1);
          break;
        default:
          this.change(+text);
          break;
      }
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f62ca93a","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/table_pagination.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPagination)?_c('div',{staticClass:"gl-pagination"},[_c('ul',{staticClass:"pagination clearfix"},_vm._l((_vm.getItems),function(item,index){return _c('li',{key:index,class:{
        page: item.page,
        'js-previous-button': item.prev,
        'js-next-button': item.next,
        'js-last-button': item.last,
        'js-first-button': item.first,
        separator: item.separator,
        active: item.active,
        disabled: item.disabled
      }},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.changePage(item.title, item.disabled)}}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])])}))]):_vm._e()}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/table_pagination.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  table_pagination,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_table_pagination = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/time_ago_tooltip.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/mixins/timeago.js
var timeago = __webpack_require__("./vue_shared/mixins/timeago.js");

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/time_ago_tooltip.vue





/**
 * Port of ruby helper time_ago_with_tooltip
 */

/* harmony default export */ var time_ago_tooltip = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  mixins: [timeago["a" /* default */]],
  props: {
    time: {
      type: String,
      required: true
    },

    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },

    cssClass: {
      type: String,
      required: false,
      default: ''
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202207e1","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/time_ago_tooltip.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"title":_vm.tooltipTitle(_vm.time),"data-placement":_vm.tooltipPlacement,"data-container":"body"}},[_vm._v("\n  "+_vm._s(_vm.timeFormated(_vm.time))+"\n")])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/time_ago_tooltip.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  time_ago_tooltip,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_time_ago_tooltip = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/mixins/timeago.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");


/**
 * Mixin with time ago methods used in some vue components
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    timeFormated: function timeFormated(time) {
      var timeago = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["d" /* getTimeago */])();

      return timeago.format(time);
    },
    tooltipTitle: function tooltipTitle(time) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["a" /* formatDate */])(time);
    }
  }
});

/***/ })

},["./pages/explore/groups/index.js"]);


// WEBPACK FOOTER //
// pages.explore.groups.4a7f530e043f3cfebe23.bundle.js